// extracted by mini-css-extract-plugin
export default {"Box":"SubIssueRemovedEvent-module__Box--jlh0k","Box_1":"SubIssueRemovedEvent-module__Box_1--pk1pA"};